import { useState } from "react";
import Item from "./Item";

export default function PackingList({ items, onDeleteItem, onUpdateItem }) {
  const [filter, setFilter] = useState("All");

  const filteredItems =
    filter === "All"
      ? items
      : items.filter((item) => item.category === filter);

  return (
    <section className="list">
      <h3>Your Packing List</h3>

      {/* Filter dropdown */}
      <select value={filter} onChange={(e) => setFilter(e.target.value)}>
        <option value="All">All Trips</option>
        <option value="Holiday">Holiday</option>
        <option value="Work">Work</option>
        <option value="School">School</option>
      </select>

      {/* EMPTY CATEGORY MESSAGE */}
      {filteredItems.length === 0 && (
        <p style={{ opacity: 0.7 }}>
          No items planned for this trip yet ✈️ Start adding some!
        </p>
      )}

      <ul>
        {filteredItems.map((item) => (
          <Item
            key={item.id}
            item={item}
            onDeleteItem={onDeleteItem}
            onUpdateItem={onUpdateItem}
          />
        ))}
      </ul>
    </section>
  );
}
